<template>
    <input
        :id="id"
        ref="input"
        type="text"
        inputmode="numeric"
        :maxlength="maxlength"
        :placeholder="placeholder"
        :value="value"
        :aria-describedby="ariadescribedby"
        @input="updateValue($event.target.value)"
        @keyup="allowOnlyInteger"
        @keyup.enter="submitKey($event.target.value)"
    />
</template>

<script>
    export default {
        props: {
            maxlength: {
                default: 5,
            },
            value: {
                default: 0,
            },
            placeholder: {
                default: '',
            },
            autofocus: {
                default: false,
            },
            id: {
                type: String,
                default: 'stInput',
            },
            ariadescribedby: {
                type: String,
                default: 'zipCodeError',
            },
        },
        mounted() {
            this.allowOnlyInteger();
        },
        methods: {
            updateValue(value) {
                this.$emit('input', value);
            },
            allowOnlyInteger(event) {
                /*
                Event keyCodes
                Backspace: 8
                Delete: 46
                Home: 36
                ArrowLeft: 37
                ArrowRight: 39
                Shift: 16
                Control: 17
                */
                if (event !== undefined && event.keyCode !== '8' && event.keyCode !== '46' && event.keyCode !== '36' && event.keyCode !== '37' && event.keyCode !== '39' && event.keyCode !== '16' && event.keyCode !== '9' && event.keyCode !== '17' && !(event.key === 'a' && event.ctrlKey)) {
                    this.$refs.input.value = String(this.value).replace(/[^0-9]/g, '');
                }
            },
            submitKey(value) {
                this.$emit('enter', value);
            },
        },
    };
</script>
